const article = {
    slug: "first_issey_miyake_experience",
    category: "BRAND ENTRY",
    title: "初めてのISSEY MIYAKE｜イッセイミヤケをレンタル体験",
    listDescription:
      "一枚の布、プリーツ、身体と空間。ISSEY MIYAKEを“着ること”から理解する入口ページ。",
    seo: {
      title:
        "初めてのISSEY MIYAKE｜イッセイミヤケをレンタル体験を着て知るEnclopedia",
      description:
        "ISSEY MIYAKEが気になるけれど、どんなブランドか分からない方へ。三宅一生の思想、生い立ち、プリーツ、一枚の布、A-POC、PLEATS PLEASE、HOMME PLISSÉなどの魅力を分かりやすく解説し、Enclopediaでレンタルできるアーカイブへ案内します。",
      keyword:
        "初めてのISSEY MIYAKE,ISSEY MIYAKE 初めて,イッセイミヤケ 初めて,ISSEY MIYAKE とは,イッセイミヤケ どんなブランド,ISSEY MIYAKE レンタル,イッセイミヤケ レンタル,ISSEY MIYAKE アーカイブ,イッセイミヤケ アーカイブ,PLEATS PLEASE レンタル,HOMME PLISSE レンタル,A-POC,イッセイミヤケ プリーツ,一枚の布,三宅一生 デザイン,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_issey_miyake_experience",
    },
    hero: {
      label: "FIRST ISSEY MIYAKE EXPERIENCE",
      number: "09 / ENTRY",
      titleLines: ["初めての", "ISSEY MIYAKEをレンタル体験。"],
      body:
        "ISSEY MIYAKEは、\n“服を美しく見せるブランド”というより、\n布、身体、動き、技術の関係そのものを考え続けてきたブランドです。\nプリーツ、一枚の布、A-POC、身体を締めつけない構造。\n初めて知るなら、まずは“着ることで分かる自由さ”から入るのが自然です。",
      keywords: [
        "first experience",
        "pleats",
        "a piece of cloth",
        "issey miyake",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["服を着るのではなく、", "布と身体の関係を体験する。"],
      image: "media/archive_fashion/archive_guide9.png",
      imageAlt:
        "初めてのISSEY MIYAKEをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるISSEY MIYAKEを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/ISSEY%20MIYAKE（イッセイミヤケ）/?number=29",
    },
    thesis: {
      text:
        "ISSEY MIYAKEは、布を身体に従わせるのではなく、布と身体が一緒に動くための服を考え続けたブランドです。",
      keywords: ["cloth", "movement", "technology"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "ISSEY MIYAKEが気になる。",
          "でも、どこから見ればいいか分からない。",
        ],
        body:
          "ISSEY MIYAKEは、プリーツの服やBAO BAOのバッグで知られています。\nしかし本質は、見た目の分かりやすいアイコンだけではありません。\n三宅一生が考え続けたのは、服を“流行の形”として作ることではなく、人が自由に動き、使い、生活できるデザインとして成立させることでした。\nこのページでは、ISSEY MIYAKEを“プリーツが有名なブランド”ではなく、“布と身体の関係を発明し続けたブランド”として整理します。",
      },
  
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "生い立ちから生まれた、",
          "人のためのデザイン。",
        ],
        body:
          "三宅一生は広島に生まれ、若い頃にイサム・ノグチが設計した橋に触れた経験から、デザインは人に見られるだけでなく、人に使われ、生活の中で力を持つものだと考えるようになります。\nその視点は、後の服作りにも深くつながっています。\n身体を無理に締めつけるのではなく、布が身体に沿い、動き、空気を含み、日常の中で使われること。\nISSEY MIYAKEの服は、彫刻のようでありながら、同時にとても実用的です。",
        knowledgeItems: [
          {
            title: "広島での経験は、“希望としてのデザイン”へつながる。",
            text:
              "三宅一生のデザインには、破壊や喪失の記憶を単に語るのではなく、そこから人が生きるための形を作るという姿勢があります。服は飾りではなく、人を前に進ませる道具になります。",
          },
          {
            title: "一枚の布は、服の原点を問い直す考え方。",
            text:
              "身体を型にはめるのではなく、一枚の布が身体の上でどう動き、どう形になるかを考える。ここにISSEY MIYAKEの根本的な面白さがあります。",
          },
          {
            title: "プリーツは、装飾ではなく機能。",
            text:
              "プリーツは見た目の表情だけでなく、伸縮性、軽さ、動きやすさ、畳みやすさを生む技術です。服をより自由にするための構造として機能します。",
          },
          {
            title: "テクノロジーと手仕事が同居する。",
            text:
              "ISSEY MIYAKEは、工業技術や新素材を使いながら、人間の身体や生活の感覚を失わないブランドです。未来的でありながら、どこか人間的です。",
          },
        ],
      },
  
      lineGuide: {
        label: "04 / HOW TO SEE ISSEY MIYAKE?",
        titleLines: [
          "ISSEY MIYAKEを見るなら、",
          "まず4つの視点から。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "A PIECE OF CLOTH",
            text:
              "一枚の布が身体の上でどう変化するか。ISSEY MIYAKEを理解する最も根本的な視点です。",
          },
          {
            tag: "ENTRY 02",
            title: "PLEATS",
            text:
              "プリーツは装飾ではなく、動きやすさ、軽さ、携帯性、立体感を同時に生む技術として見ると面白くなります。",
          },
          {
            tag: "ENTRY 03",
            title: "BODY & MOVEMENT",
            text:
              "服が身体を固定するのではなく、身体の動きに反応する。歩く、座る、腕を上げる。そのたびに服の形が変わります。",
          },
          {
            tag: "ENTRY 04",
            title: "TECHNOLOGY & DAILY LIFE",
            text:
              "A-POCやHOMME PLISSÉのように、技術が実験で終わらず、日常で着られる服へ落とし込まれる点が重要です。",
          },
        ],
      },
  
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "ISSEY MIYAKEの服は、ハンガーに掛かっている状態と、身体に乗せた状態で印象が大きく変わります。",
        items: [
          {
            index: "01",
            title: "軽さが、見た目以上に身体を変える",
            text:
              "プリーツや薄い素材は、服を着ている重さを忘れさせます。身体を締めつけず、動きに合わせて形が変わるため、着た瞬間に自由さが分かります。",
          },
          {
            index: "02",
            title: "平面と立体の行き来が面白い",
            text:
              "畳まれていると平面的なのに、着ると立体になる。ISSEY MIYAKEの服は、布が身体によって完成する感覚があります。",
          },
          {
            index: "03",
            title: "“楽な服”なのに、緊張感がある",
            text:
              "着心地は楽なのに、見た目には彫刻的な強さがある。この矛盾がISSEY MIYAKEの魅力です。日常着と実験服が同時に成立しています。",
          },
        ],
      },
  
      quote: {
        textLines: [
          "布は、身体に従うだけではない。",
          "身体と一緒に動き、形を作る。",
        ],
      },
  
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: [
          "初めてのISSEY MIYAKEほど、",
          "レンタルで理解が深まる。",
        ],
        items: [
          {
            number: "01",
            title: "写真では、軽さと動きが伝わりきらない",
            text:
              "プリーツの伸縮、布の揺れ、身体に沿う感覚は、写真では分かりにくい部分です。実際に着ることで初めて理解できます。",
          },
          {
            number: "02",
            title: "自分の身体との相性を確かめられる",
            text:
              "ISSEY MIYAKEの服は、体型を隠すのではなく、身体の動きに反応します。サイズ表だけでは分からない相性を体験できます。",
          },
          {
            number: "03",
            title: "ブランドの思想を、生活の中で試せる",
            text:
              "美術館で見るような服ではなく、実際に歩き、座り、動くことで意味が分かる服です。レンタルはその思想に触れる最短の入口になります。",
          },
        ],
      },
  
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるISSEY MIYAKE。"],
        body:
          "実在庫への導線は、“ISSEY MIYAKEを知る続き”として設計します。まず背景を理解し、次に実物で確かめる流れを作ります。",
        items: [
          {
            meta: "ISSEY MIYAKE MEN / 2019AW Wind",
            title: "テーラードジャケット",
            text:
              "2019AWのキーワードである“風”を背景に、軽さや動き、空気を含むような着用感をテーラードの形に落とし込んだ一着。",
            href:
              "https://www.enclopedia-official.com/product/c8c69666-09c6-4717-b1f7-19efbbf0a11c",
            image:
              "media/product/1779192290.4588382c8c69666-09c6-4717-b1f7-19efbbf0a11c.png"
          },
          {
            meta: "ISSEY MIYAKE / 2024SS Grasping the Formless",
            title: "ノーカラージャケット",
            text:
              "“見えない形が見えるまで”をテーマに、風や光のように輪郭のないものを服へ写した2024SS。余白のある形と身体への自然な呼応を感じられるジャケット。",
            href:
              "https://www.enclopedia-official.com/product/a1acaa9e-af5a-486c-96c8-c4b8a4e5d37c",
            image:
              "media/product/1755089006.0275738a1acaa9e-af5a-486c-96c8-c4b8a4e5d37c.jpg",
          },
          {
            meta: "PLEATS PLEASE ISSEY MIYAKE / 2010AW",
            title: "マルチカラープリーツワンピース",
            text:
              "軽く、畳めて、動きに強いPLEATS PLEASEの特性を、マルチカラーの表情で楽しめるワンピース。身体の動きに合わせて色とプリーツが変化します。",
            href:
              "https://www.enclopedia-official.com/product/a4f03d17-f41f-4324-b74b-463b88f77525",
            image:
              "media/product/1768315424.469848a4f03d17-f41f-4324-b74b-463b88f77525.jpg",
          },
        ],
      },
  
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "ISSEY MIYAKEは、どんなブランドですか？",
            answer:
              "布、身体、動き、技術の関係を考え続けてきたブランドです。プリーツやA-POCなど、服作りそのものを更新する発想が特徴です。",
          },
          {
            question: "ISSEY MIYAKEとPLEATS PLEASEは違いますか？",
            answer:
              "はい。ISSEY MIYAKEはブランド全体の中核で、PLEATS PLEASEはプリーツ技術を日常着として展開する代表的なラインです。",
          },
          {
            question: "HOMME PLISSÉ ISSEY MIYAKEはどんなラインですか？",
            answer:
              "メンズ向けに発展したプリーツのラインです。動きやすさ、軽さ、扱いやすさがありながら、独特の立体感があります。",
          },
          {
            question: "初めてなら、どのアイテムから見るのがおすすめですか？",
            answer:
              "プリーツパンツ、ジャケット、トップスなど、日常的に着やすく、動いたときの変化が分かるアイテムがおすすめです。",
          },
          {
            question: "写真と実物で印象は変わりますか？",
            answer:
              "大きく変わります。プリーツの伸縮、布の軽さ、動いたときの揺れは、実物で着ると最も分かりやすい要素です。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
  
      finalCta: {
        titleLines: [
          "初めてのISSEY MIYAKEを、",
          "レンタルから始める。",
        ],
        body:
          "一枚の布、プリーツ、身体の動き、技術の美しさ。\nEnclopediaで、ISSEY MIYAKEのアーカイブを体験してください。",
        buttonLabel: "レンタルできるISSEY MIYAKEを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/ISSEY%20MIYAKE（イッセイミヤケ）/?number=29",
      },
    },
  };

export default article;
